import { render, staticRenderFns } from "./DispatchOrder.vue?vue&type=template&id=cff018bc&scoped=true"
import script from "./DispatchOrder.vue?vue&type=script&lang=js"
export * from "./DispatchOrder.vue?vue&type=script&lang=js"
import style0 from "./DispatchOrder.vue?vue&type=style&index=0&id=cff018bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff018bc",
  null
  
)

/* custom blocks */
import block0 from "./DispatchOrder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports